/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _ */

_.namespace(`mp.marketing.trends`, function(ns) {
  'use strict';

  ns.StaticViewer = ns.ReportViewer.extend({
    // We do not want to render a date picker for a static view/
    render_date_picker() {
      this.date_picker = {remove() {}};
    },
  });
});

}.call(window));